exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body{margin:0;padding:0;font-family:sans-serif;overflow:hidden}i,ins{font-style:normal;text-decoration:none}ul{padding:0}ul li{list-style:none !important}ul,li{margin:0;padding:0}p{margin:0}.c_inline{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/styles/reset.scss
// module id = 974
// module chunks = 0